import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

const FarmerGrowthChart = () => {
    const distID = localStorage.getItem('distributorId');
    const { data: monthlyStats, error: monthlyError, isLoaded: monthlyLoaded } = GetRequest(`/Farmer/GetFarmerStatsForDistributorArea/${distID}`);

    if (monthlyError) {
        return <Error data="Farmer Growth Chart" />;
    }
    if (!monthlyLoaded) {
        return <Loading />;
    }

    // Group data by Taluka and sort months chronologically
    const talukaGroups = {};
    monthlyStats.result.forEach(stat => {
        if (!talukaGroups[stat.talukaName]) {
            talukaGroups[stat.talukaName] = [];
        }
        talukaGroups[stat.talukaName].push({
            monthYear: stat.monthYear,
            cumulativeFarmers: stat.cumulativeFarmers
        });
    });

    // Sort each Taluka's data by date (assuming YYYY-MM format)
    Object.keys(talukaGroups).forEach(taluka => {
        talukaGroups[taluka].sort((a, b) => new Date(a.monthYear) - new Date(b.monthYear));
    });

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-warning">
                                <h5 className="card-title">Farmer Growth Trends</h5>
                            </div>
                            <div className="card-body">
                                {Object.keys(talukaGroups).map((taluka, index) => (
                                    <div key={index} className="mb-4">
                                        <h6 className="text-center text-bold">{taluka}</h6>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <LineChart data={talukaGroups[taluka]}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="monthYear" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Line type="monotone" dataKey="cumulativeFarmers" stroke="#8884d8" strokeWidth={2} />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FarmerGrowthChart;
